import Vue from 'vue';
import VueRouter from 'vue-router';
import { deleteMantisChat, whatEev } from '@/utils/tools';
// eslint-disable-next-line
// import { search } from 'core-js/fn/symbol';
import wechatServiceNum from '@/router/wechatBinding';
import learningGuidePage from '@/router/learningGuidePage';
// eslint-disable-next-line import/no-cycle
import { wechatJSConfig } from '@/utils/common';
import coupon from './coupon';
import learn from './learn';
import person from './person';
import video from './video';
import pay from './pay';
import courseDetail from './courseDetail';
import registrationLogin from './registrationLogin';
import productList from './productList';
import combinationList from './combinationList';
import searchindex from './search';
import messageList from './messageList';
import activity from './activity';// 所有活动页路由
import activationCourse from './activationCourse'; // 课程卡激活
import recommendList from './recommendList';
import live from './live';
import liveBJY from './liveBJY';
import playback from './playback';
import foot from './foot';
import combinationCourse from './combinationCourse';
import recentMoreLiveCourse from './recentMoreLiveCourse';// 直播公开课
import teacherDetail from './teacherDetail';// 教师介绍

import newUserRegister from './newUserRegister';
import cet from './cet';
import japan from './japan';
import accounting from './accounting';
import reexamine from './reexamine';
import exam24 from './exam24';
import exam25 from './exam25';
import exam26 from './exam26';
import collegeExam from './collegeExam';
import qihangAgree from './qihangAgree';
import shoppingCar from './shoppingCar';
import securityCode from './securityCode';
import majorSenior from './majorSenior';
import openMiniApp from './openMiniApp';
// 入学信息
import archives from './archives';
import entranceTask from './entranceTask';
// 拉新
import pullNew from './pullNew';
// 打卡
import checkActive from './checkActive';

// 过渡页
import transition from './transition';
// b站发货
import bilibiliShipmens from './bilibiliShipmens';
import notes30 from './notes30';

import share from './share';
import vipProduct from './vipProduct';
import svipProduct from './svipProduct';
import studyBook from './studyBook';
import invitationCommission from './invitationCommission';
import oneToOne from './oneToOne';
import collectCard from './collectCard'
import examPlan from './examPlan';

import cardCollecting from './cardCollecting';



import othersPay from './othersPay';
import trainEntrance from './trainEntrance';
import invoice from './invoice'

const dictionary = () => import('@/pages/arkHome/dictionary.vue');
const ztList = () => import('@/pages/arkHome/components/ztList.vue');
const Arkexam24 = () => import('@/pages/exam24/index.vue');
const Arkexam23 = () => import('@/pages/arkHome/home.vue');
const businessOrder = () => import('@/pages/businessOrder/index.vue');
const systemNotifications = () => import('@/pages/systemNotifications/index.vue');
const minilink = () => import('@/pages/miniLink');
const miniRedict = () => import('@/pages/miniRedict/index.vue');
const chooseMiniSkip = () => import('@/pages/chooseMiniSkip/index.vue');
const minilinkUpgrade = () => import('@/pages/miniLink/minilinkUpgrade.vue');
const commonExamYear = () => import('@/pages/commonExamYear');
const examOutline = () => import('@/pages/examOutline');
const cardRule = () => import('@/pages/collectCard/rule.vue');
const cardPrizeList = () => import('@/pages/collectCard/prizeList.vue');
const cardAdress = () => import('@/pages/collectCard/adress.vue');
const cardExchange = () => import('@/pages/collectCard/exchange.vue');
const cardRecord = () => import('@/pages/collectCard/record.vue');
const cardPhoto = () => import('@/pages/collectCard/photo.vue');
const aiAssistant = () => import('@/pages/aiAssistant/index.vue')
const registration = () => import('@/pages/registration/index.vue');
const registrationTwo = () => import('@/pages/registrationTwo/index.vue');

const aiCompanionChat = () => import('@/pages/aiCompanionChat/index.vue')

const bookMall = () => import('@/pages/bookMall/index.vue')
const searchPage = () => import('@/pages/bookMall/searchPage.vue')

const courseCompletionActivity = () => import('@/pages/courseCompletionActivity/courseCompletionActivity.vue')

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: Arkexam24,
  },
  {
    path: '/home',
    name: 'home',
    component: Arkexam24,
  },
  {
    path: '/exam23',
    name: 'exam23',
    component: Arkexam23,
  },
  {
    path: '/dictionary',
    name: 'dictionary',
    component: dictionary,
  },
  {
    path: '/jixunList',
    name: 'ztList',
    component: ztList,
  },
  {
    path: '/businessOrder',
    name: 'businessOrder',
    component: businessOrder,
    meta: {
      title: '订单快递查询',
    },
  },
  {
    path: '/minilink',
    name: 'minilink',
    component: minilink,
    meta: {
      title: '爱启航之家',
      requireAuth: false,
    },
  },
  {
    path: '/miniRedict/:code',
    name: 'miniRedict',
    component: miniRedict,
    meta: {
      title: '小程序跳转',
      requireAuth: false,
    },
  },
  {
    path: '/chooseMiniSkip/:code',
    name: 'chooseMiniSkip',
    component: chooseMiniSkip,
    meta: {
      title: '小程序跳转',
      requireAuth: false,
    },
  },
  {
    path: '/minilinkUpgrade',
    name: 'minilinkUpgrade',
    component: minilinkUpgrade,
    meta: {
      title: '',
      requireAuth: false,
    },
  },
  {
    path: '/systemNotifications',
    name: 'systemNotifications',
    component: systemNotifications,
    meta: {
      title: '系统维护',
      requireAuth: false,
    },
  },
  {
    path: '/commonExamYear',
    name: 'commonExamYear',
    component: commonExamYear,
  },
  {
    path: '/examOutline',
    name: 'examOutline',
    component: examOutline,
  },
  {
    path: '/cardRule',
    name: 'cardRule',
    component: cardRule,
  },
  {
    path: '/cardPrizeList',
    name: 'cardPrizeList',
    component: cardPrizeList,
  },
  {
    path: '/cardAdress',
    name: 'cardAdress',
    component: cardAdress,
  },
  {
    path: '/cardExchange',
    name: 'cardExchange',
    component: cardExchange,
  },
  {
    path: '/cardRecord',
    name: 'cardRecord',
    component: cardRecord,
  },
  {
    path: '/cardPhoto',
    name: 'cardPhoto',
    component: cardPhoto,
  },
  {
    path: '/aiAssistantZz',
    name: 'aiAssistantZz',
    component: aiAssistant,
  },
  {
    path: '/aiAssistantTk',
    name: 'aiAssistantTk',
    component: aiAssistant,
  },
  {
    path: '/aiAssistantYtZz',
    name: 'aiAssistantTk',
    component: aiAssistant,
  },
  {
    path: '/aiCompanionChat',
    name: 'aiCompanionChat',
    component: aiCompanionChat,
  },
  {
    path: '/registration',
    name: 'registration',
    component: registration,
  },
  {
    path: '/registrationTwo',
    name: 'registrationTwo',
    component: registrationTwo,
  },
  {
    path: '/bookMall',
    name: 'bookMall',
    component: bookMall,
  },
  {
    path: '/bookSearchPage',
    name: 'searchPage',
    component: searchPage,
  },
  {
    path: '/courseCompletionActivity',
    name: 'courseCompletionActivity',
    component: courseCompletionActivity,
  },
  ...coupon,
  ...learn,
  ...person,
  ...video,
  ...pay,
  ...courseDetail,
  ...registrationLogin,
  ...productList,
  ...searchindex,
  ...messageList,
  ...wechatServiceNum,
  ...activity,
  ...learningGuidePage,
  ...live,
  ...liveBJY,
  ...playback,
  ...activationCourse,
  ...foot,
  ...combinationCourse,
  ...newUserRegister,
  ...cet,
  ...japan,
  ...accounting,
  ...reexamine,
  ...exam24,
  ...collegeExam,
  ...recommendList,
  ...recentMoreLiveCourse,
  ...teacherDetail,
  ...qihangAgree,
  ...combinationList,
  ...shoppingCar,
  ...archives,
  ...entranceTask,
  ...transition,
  ...pullNew,
  ...checkActive,
  ...securityCode,
  ...exam25,
  ...exam26,
  ...majorSenior,
  ...openMiniApp,
  ...bilibiliShipmens,
  ...notes30,
  ...share,
  ...vipProduct,
  ...svipProduct,
  ...studyBook,
  ...invitationCommission,
  ...cardCollecting,
  ...oneToOne,
  ...collectCard,
  ...othersPay,
  ...examPlan,
  ...trainEntrance,
  ...invoice,
];

const originalPush = VueRouter.prototype.push;
const originalReplace = VueRouter.prototype.replace;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch((err) => err);
};

// replace
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject);
  return originalReplace.call(this, location).catch((err) => err);
};

const router = new VueRouter({
  mode: 'history',
  base: 'ark',
  routes,
});
// console.log('router.js');
router.beforeEach((to, from, next) => {

  // 先删除一下ai咨询
  if (document.getElementById('AI_WIRE_CONNECTION_DOM')) {
    document.body.removeChild(document.getElementById('AI_WIRE_CONNECTION_DOM'));
  } else {
    setTimeout(() => {
      if (document.getElementById('AI_WIRE_CONNECTION_DOM') && !['courseDetail', 'combinationCourse'].includes(toName)) {
        document.body.removeChild(document.getElementById('AI_WIRE_CONNECTION_DOM'));
      }
    }, 1000);
  }

  let WGHITELIST = ['courseDetail', 'combinationCourse', 'pullNew', 'productList', 'recommendList', 'combinationList'];
  if (whatEev() === 'miniprogram') { // 小程序productList ，不需要客服
    WGHITELIST = WGHITELIST.filter((item) => item !== 'productList');
  }
  if (!WGHITELIST.includes(to.name)) {
    deleteMantisChat();
  }
  if (from.path === '/' && navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1) {
    wechatJSConfig();
    window.sessionStorage.setItem('wxConfigHasInit', 'hasInit');
  }

  const tokenParams = window.localStorage.getItem('accessToken');
  if (!tokenParams) {
    // query 参数
    const oldPagesQuery = window.localStorage.getItem('pagesQuery');
    const newPagesQuery = Object.keys(to.query);
    // params 参数
    const oldPagesParams = window.localStorage.getItem('pagesParams');
    const newPagesParams = Object.keys(to.params);
    if (
      newPagesQuery.length > 0
      && (!oldPagesQuery || (oldPagesQuery !== newPagesQuery))
    ) {
      const newParams = to.query;
      window.localStorage.setItem('pagesQuery', JSON.stringify(newParams));
    }

    if (
      newPagesParams.length > 0
      && (!oldPagesParams || (oldPagesParams !== newPagesParams))
    ) {
      const newParams = to.params;
      window.localStorage.setItem('pagesParams', JSON.stringify(newParams));
    }

    // if (to.path === '/registrationLogin') {
    //   window.localStorage.setItem('fromPath', from.path);
    // }
  }

  if (to.meta.requireAuth) {
    const token = window.localStorage.getItem('accessToken');
    if (token || (window?.navigator?.userAgent || '').includes('iqihang')) {
      // if (from.path === '/passwordLogin' || from.path === '/getCode') {
      //   const backlen = window.history.length > 2 ? 2 : 0;
      //   window.history.go(-backlen);
      // }
      next();
    } else {
      next({
        path: '/registrationLogin',
        query: { redirect: to.fullPath }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
      });
    }
  } else {
    next();
  }
});

router.afterEach(() => {
  if (window.setArkAdaptiveRem) {
    window.setArkAdaptiveRem();
  }
});

export default router;
